module.exports = __webpack_public_path__ + "img/ROMA.a000f611.png";